import { useEffect as i } from "react";
function u({
  commentRef: r,
  isFocused: o
}) {
  i(() => {
    o && setTimeout(() => {
      var t;
      (t = r == null ? void 0 : r.current) == null || t.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }, 500);
  }, [o]);
}
export {
  u as useScrollToComment
};
